/* eslint-disable react-hooks/exhaustive-deps */
import { useFormik } from 'formik';
import  { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';

 import { useTranslation } from 'react-i18next';
import { formJob } from '../../../ValidationForm/validationSchema';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import {
  getGroupEmp,
  getGroupEmpById,
  updateGroup,
} from '../../../../store/HR/HRSetting/groupEmpSlice';
import { usePermissions } from '../../../../Helper/Permisstions/usePermissions';
import Loading from '../../../../components/Shared/Loader/Loading';

const EditGroupEmployees = ({ id }) => {
  const { HasPermission } = usePermissions();

  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { loading, error, GroupEmp } = useSelector((state) => state.Groups);

  useEffect(() => {
    if (!GroupEmp?.length) {
      dispatch(getGroupEmpById(id));
    }
  }, [dispatch, id]);

  console.log(GroupEmp);

  const formik = useFormik({
    initialValues: {
      name2: GroupEmp ? GroupEmp.name2 : '',
      name: GroupEmp ? GroupEmp.name : '',
      comments: GroupEmp ? GroupEmp.comments : '',
    },
    enableReinitialize: true,
    validationSchema: formJob(t),
    onSubmit: (values) => {
      dispatch(
        updateGroup({
          id: GroupEmp.id,
          name2: values.name2,
          name: values.name,
          comments: values.comments,
        })
      )
        .unwrap()
        .then(() => {
          CustomAlert({ action: 'Edit' });
          // Navigate('/HR/HRsettings');
          dispatch(getGroupEmp());
        })
        .catch((error) => {
          console.log(error);
          CustomAlert({ action: 'Error' });
        })
        .finally(() => formik.setSubmitting(false));
    },
  });

  return (
    <>
      <Loading loading={loading} error={error}>
        <Form onSubmit={formik.handleSubmit}>
          <div className="row">
            <div className="col-xl-6">
              <div className="form-group mb-3">
                <label className="form-label">{t('LocalName')}</label>
                <Form.Control
                  className="form-control"
                  type="text"
                  autoComplete="off"
                  name="name"
                  onChange={formik.handleChange}
                  value={formik.values.name || ''}
                  isInvalid={!!formik.errors.name}
                />
                <Form.Control.Feedback type="invalid">{formik.errors.name}</Form.Control.Feedback>
              </div>
            </div>

            <div className="col-xl-6">
              <div className="form-group mb-3">
                <label className="form-label">{t('GlobalName')}</label>
                <Form.Control
                  className="form-control"
                  type="text"
                  autoComplete="off"
                  name="name2"
                  onChange={formik.handleChange}
                  value={formik.values.name2 || ''}
                  isInvalid={!!formik.errors.name2}
                />
                <Form.Control.Feedback type="invalid">{formik.errors.name2}</Form.Control.Feedback>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="form-group mb-3">
                <label className="form-label">{t('Note')}</label>
                <Form.Control
                  className="form-control"
                  as="textarea"
                  rows={3}
                  name="comments"
                  onChange={formik.handleChange}
                  value={formik.values.comments || ''}
                  isInvalid={!!formik.errors.comments}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.comments}
                </Form.Control.Feedback>
                <div></div>
              </div>
            </div>
          </div>

          <div className="text-center">
            <div className="d-flex justify-content-between gap-2">
              {HasPermission('EditHrPerGroups') && (
                <button
                  disabled={formik.isSubmitting}
                  type="submit"
                  className="btn btn-lg btn-theme mb-1 w-100">
                  {formik.isSubmitting ? (
                    <div className="spinner-border spinner-border-sm me-2"></div>
                  ) : (
                    <i className="fas fa-save fa-lg fa-fw me-2"></i>
                  )}
                  {t('Save')}
                </button>
              )}
              <button
                type="button"
                className="btn btn-lg  btn-default mb-1 w-100"
                data-bs-dismiss="modal"
                id="closeModalJob">
                <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
              </button>
            </div>
          </div>
        </Form>
      </Loading>
    </>
  );
};

export default EditGroupEmployees;
